import { render, staticRenderFns } from "./UpdatePwdDialog.vue?vue&type=template&id=a5f4e0fe&scoped=true"
import script from "./UpdatePwdDialog.vue?vue&type=script&lang=ts"
export * from "./UpdatePwdDialog.vue?vue&type=script&lang=ts"
import style0 from "./UpdatePwdDialog.vue?vue&type=style&index=0&id=a5f4e0fe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f4e0fe",
  null
  
)

export default component.exports